module.exports = __webpack_public_path__ + "img/b68d925cbdee9ac8f80c4e4edd63aa0f.bb8d64e2.png";